export default __webpack_public_path__ + "static/media/close.180a8fb7.svg";